import Vue from 'vue'
import Console from './index.vue'
import router from './router'
import 'lib-flexible'
import '@/icons' // icon
import '@/assets/index.less' // global css
import './permission.js'
import '@vant/touch-emulator'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
Vue.use(require('vue-wechat-title'))

// 阻止手机自身事件
// document.body.addEventListener('touchmove', function(e) {
//   e.preventDefault()
// }, { passive: false })

Sentry.init({
  Vue,
  dsn: 'https://37144d3c8d4d49948bb7210144322c76@sentry.yes-go.cn/4',
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router)
    })
  ],
  sendDefaultPii: true,
  trackComponents: true,
  release: 'crm-mobile-apply', // 版本号
  tracesSampleRate: 1.0,
  environment: process.env.NODE_ENV,
  attachProps: true
})

new Vue({
  router,
  render: h => h(Console)
}).$mount('#apply')
